/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {lastMonth, lastWeek, today} from '@ion/core/src/utils/DateUtil';
/**
 * Defines a mapping of selected dates to their respective date util function calls.
 */
export const dateFilterMap = {
  today      : today(),
  last7days  : lastWeek(),
  last30days : lastMonth()
};

export default dateFilterMap;
